import { graphql } from "gatsby";
import React from "react";
import { SubjectParentBreadcrumbsFragment } from "../../graphql-types";

import { BreadcrumbItem } from "../components/BreadcrumbItem";

interface Props extends SubjectParentBreadcrumbsFragment {
  parentSubject?: SubjectParentBreadcrumbsFragment | null;
}

export const SubjectParentBreadcrumbs: React.FC<Props> = ({
  absolutePath,
  pageTitle,
  parentSubject,
}) => (
  <>
    {parentSubject && <SubjectParentBreadcrumbs {...parentSubject} />}
    <BreadcrumbItem to={absolutePath} label={pageTitle} />
  </>
);

// NOTE: No site has more than four levels of nesting currently
export const fragments = graphql`
  fragment SubjectParentBreadcrumbsFields on Subject {
    absolutePath
    pageTitle
  }

  fragment SubjectParentBreadcrumbs on Subject {
    ...SubjectParentBreadcrumbsFields
    parentSubject {
      ...SubjectParentBreadcrumbsFields
      parentSubject {
        ...SubjectParentBreadcrumbsFields
        parentSubject {
          ...SubjectParentBreadcrumbsFields
        }
      }
    }
  }
`;
